module.exports = __webpack_public_path__ + "static/media/crosson.a49a1a3e.svg";